import { SocialChannelEnum } from '@/app/common/general-types/briefs.dto';
import { SubmittedPostDto } from '@/app/common/general-types/submitted-posts.dto';
import { Component, EventEmitter, inject, Input, OnInit, Output, signal } from '@angular/core';
import { FormField, form, required } from '@angular/forms/signals';
import { SubmittedPostsService } from '@/app/services/submitted-posts/submitted-posts.service';
import { ViewportOverlayDirective } from '@/app/common/directives/viewport-overlay/viewport-overlay.directive';

@Component({
  selector: 'ipr-edit-submitted-post',
  imports: [FormField],
  hostDirectives: [ViewportOverlayDirective],
  templateUrl: './edit-submitted-post.html',
  styleUrl: './edit-submitted-post.css',
  host: {
    '(document:keydown.escape)': 'closeEditSubmittedPost()'
  }
})
export class EditSubmittedPost implements OnInit {

  @Input() focussedSubmittedPost!: SubmittedPostDto;
  @Output() close = new EventEmitter<void>();
  @Output() saved = new EventEmitter<SubmittedPostDto>();

  sendingRequest = signal<boolean>(false);
  requestSent = signal<boolean>(false);

  updatedSubmittedPost = signal<SubmittedPostDto | undefined>(undefined);

  requestModel = signal({
    link: '',
    adCode: '',
  });
  requestForm = form(this.requestModel, (schemaPath) => {
    required(schemaPath.link, { message: 'Link is required' });
  });

  /** Services */
  private submittedPostsService = inject(SubmittedPostsService);
  /** Services - END */

  ngOnInit(): void {
    this.requestModel().link = this.focussedSubmittedPost.videoLink;
    this.requestModel().adCode = this.focussedSubmittedPost.adCode || '';
  }

  saveChanges() {
    console.log('saveChanges()');
    console.log('requestModel: ', this.requestModel());
    this.sendingRequest.set(true);
    this.submittedPostsService.updateVideoLink(this.focussedSubmittedPost.id, this.requestModel().link, this.requestModel().adCode).subscribe({
      next: (response: any) => {
        console.log('response: ', response);
        this.updatedSubmittedPost.set(response);
        this.sendingRequest.set(false);
        this.requestSent.set(true);
      },
      error: (error: any) => {
        console.error('error: ', error);
        this.sendingRequest.set(false);
      }
    });
  }

  getPlaceholder_AdCode() {
    switch (this.focussedSubmittedPost.socialChannel) {
      case SocialChannelEnum['Instagram Reel']:
        return 'adcode-aBcDeFgHijKlMnOpQrStUvWxYz';
      case SocialChannelEnum['TikTok Post']:
        return '#aBcDeFgHijKlMnOpQrStUvWxYz==';
      case SocialChannelEnum['YouTube Shorts']:
        return '1234567890';
      case SocialChannelEnum['Snapchat Spotlight']:
        return '1234567890';
      case SocialChannelEnum['Snapchat Story']:
        return '1234567890';
      default:
        return '1234567890';
    }
  }

  getPlaceholder_Link() {
    switch (this.focussedSubmittedPost.socialChannel) {
      case SocialChannelEnum['Instagram Reel']:
        return 'https://www.instagram.com/p/aBcDeFgHijKlMnOpQrStUvWxYz/';
      case SocialChannelEnum['TikTok Post']:
        return 'https://www.tiktok.com/@user/aBcDeFgHijKlMnOpQrStUvWxYz';
      case SocialChannelEnum['YouTube Shorts']:
        return 'https://www.youtube.com/shorts/aBcDeFgHijKlMnOpQrStUvWxYz';
      case SocialChannelEnum['Snapchat Spotlight']:
        return 'https://www.snapchat.com/example';
      case SocialChannelEnum['Snapchat Story']:
        return 'https://www.snapchat.com/example';
      default:
        return '1234567890';
    }
  }

  closeEditSubmittedPost() {
    if (this.requestSent()) {
      this.saved.emit(this.updatedSubmittedPost()!);
    } else {
      this.close.emit();
    }
  }
}
